import React, { Component } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import './assets/scss/common/normalize.css';


import NotFound from './pages/NotFound';
import Main from './pages/Main';
import Calendar from './pages/Calendar';
import Comment from './pages/Comment';
import Policy from './pages/Policy';


import Login from './pages/account/Login';
import Join from './pages/account/Join';
import Find from './pages/account/Find';
import Profile from './pages/account/Profile';


import Start from './pages/words/Start';
import View from './pages/words/View';
import Finish from './pages/words/Finish';
import Result from './pages/words/List';
import Detail from './pages/words/Detail';
import Curriculum from './pages/words/Curriculum';
import Admin from './pages/Admin';

import LessonStart from './app/LessonStart';
import Lesson from './app/Lesson';
import { Review, WordList } from './app/Review';
import { Talk, TalkUnit, Grammar } from './app/Talk';



class App extends Component {
  render() {
    return (
      <Routes>
        <Route path="/" index element={<Login />}></Route>
        <Route path="/Main" element={<Main />}></Route>
        <Route path="/Calendar" element={<Calendar />}></Route>
        <Route path="/Comment" element={<Comment />}></Route>

        <Route path="/Login" element={<Login />}></Route>
        <Route path="/Join" element={<Join />}></Route>
        <Route path="/Find" element={<Find />}></Route>
        <Route path="/Profile" element={<Profile />}></Route>
        <Route path="/Terms" element={<Policy kind="terms" />}></Route>
        <Route path="/Privacy" element={<Policy kind="privacy" />}></Route>


        <Route path="/Challenge" element={<Start />}></Route>
        <Route path="/Challenge/View" element={<View />}></Route>
        <Route path="/Challenge/Finish" element={<Finish />}></Route>

        <Route path="/Challenge/Result" element={<Result />}></Route>
        <Route path="/Challenge/Detail" element={<Detail />}></Route>

        {/* Daily lesson (FSRS reviews + new words); free practice keeps the original count-based study */}
        <Route path="/Study" element={<LessonStart />}></Route>
        <Route path="/Study/Lesson" element={<Lesson />}></Route>
        <Route path="/Study/Free" element={<Start />}></Route>
        <Route path="/Study/Curriculum" element={<Curriculum />}></Route>
        <Route path="/Study/View" element={<View />}></Route>
        <Route path="/Study/Finish" element={<Finish />}></Route>

        <Route path="/Review" element={<Review />}></Route>
        <Route path="/Review/Session" element={<Lesson mode="review" />}></Route>
        <Route path="/Review/Words/:filter" element={<WordList />}></Route>

        <Route path="/Talk" element={<Talk />}></Route>
        <Route path="/Talk/:track/:unit" element={<TalkUnit />}></Route>
        <Route path="/Grammar/:no" element={<Grammar />}></Route>

        <Route path="/Admin" element={<Admin />}></Route>

        {/* Links from the short-lived separate new-UI build */}
        <Route path="/app/*" element={<Navigate to="/Main" replace />}></Route>


        <Route path="*" element={<NotFound />}></Route>
      </Routes>
    )
  }
}

export default App;
